import React, { useEffect } from 'react';
import { tv } from 'tailwind-variants';
import VocabDeckCard from '@/components/common/VocabularyCards/VocabDeckCard';
import { IUser } from '@/components/common/VocabularyCards/interfaces';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient, useVocabDecksStore } from '@/components/common/VocabularyCards/variables';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import IGlossaryTerm from '@/components/interfaces/GlossaryTerm';
import { useVocabStoreDecks } from '@/components/common/VocabularyCards/hooks/useDecks';
import useFlags from '@/hooks/useFlags';

interface SharedProps {
  tciGlossaryTerms: IGlossaryTerm[];
}

const vocabularyCardsStyles = tv({
  base: 'tw-flex tw-flex-wrap tw-gap-16 tw-mt-10',
  variants: {
    reflow: {
      true: 'tw-justify-center tw-items-center tw-mt-4 tw-gap-6 reflow-narrow:tw-justify-start reflow-narrow:tw-items-start reflow-narrow:tw-mt-10 reflow-narrow:tw-gap-16',
    },
  },
});

const VocabularyCards = ({ tciGlossaryTerms }: SharedProps) => {
  const { data: decks, refetch } = useVocabStoreDecks();
  const { accessibilityReflow } = useFlags();

  return (
    <div className={vocabularyCardsStyles({ reflow: accessibilityReflow })}>
      <VocabDeckCard
        deck={{
          glossary_term_models: [],
          id: -1,
          staffer: { first_name: 'TCI', last_name: 'TCI' },
          staffer_id: 0,
          title_en: 'TCI Vocabulary Deck',
          title_es: 'Tarjetas de Vocabulario TCI',
          total_terms: tciGlossaryTerms.length,
          updated_at: '',
        }}
        refetch={refetch}
      />
      {decks.map(deck => (
        <VocabDeckCard key={deck.id} deck={deck} refetch={refetch} />
      ))}
    </div>
  );
};

interface Props extends SharedProps {
  currentUser: IUser;
  lessonId: number;
  programId: number;
}

const VocabularyCardsWrapper = ({ currentUser, lessonId, programId, tciGlossaryTerms }: Props) => {
  const store = useVocabDecksStore();

  useEffect(() => store.setStore({ currentUser, lessonId, programId }), [currentUser, lessonId, programId]);

  if (!(store.lessonId && store.programId && store.currentUser)) return null;

  return (
    <QueryClientProvider client={queryClient}>
      <ReactQueryDevtools initialIsOpen={false} />
      <VocabularyCards tciGlossaryTerms={tciGlossaryTerms} />
    </QueryClientProvider>
  );
};

export default VocabularyCardsWrapper;
